import { useAtomValue } from 'jotai';
import { useTranslationWithMobile } from '../../../../hooks/useTranslationWithMobile';
import { Box, Heading, Text } from '@wix/design-system';
import React from 'react';
import AiAssistantIcon from '../../../ProgressBar/ai-assistant-light-theme.svg';
import { currentStepAtom, stepsAtom, backgroundAtom } from '../../context/progressBarAtoms';
import s from './ProgressHeader.scss';

export const ProgressHeader: React.FC = () => {
  const { t } = useTranslationWithMobile();
  const currentStep = useAtomValue(currentStepAtom);
  const steps = useAtomValue(stepsAtom);
  const background = useAtomValue(backgroundAtom);

  return (
    <Box className={s.root} direction="vertical" style={background ? { background } : undefined} gap={10}>
      <Box direction="vertical" gap={2}>
        <Heading>{t('store_launch.main_content.header')}</Heading>

        <Text className={s.subtitle}>{t('store_launch.main_content.subtitle')}</Text>
      </Box>

      <Box className={s.icon}>
        <AiAssistantIcon width="80px" height="80px" />
      </Box>

      <Box className={s.progressContainer} direction="vertical" gap={3}>
        <Box className={s.progressBarBg}>
          <Box
            className={s.progressBarFg}
            style={{
              ['--progress-bar-width' as any]: `${(currentStep / (steps?.length || 1)) * 100}%`,
            }}
          />
        </Box>

        <Heading size="tiny">{t('PLEASE_WAIT_WHILE_WE_SET_UP_YOUR_STORE')}</Heading>
      </Box>
    </Box>
  );
};
